import { company } from '../../data/content';

export const buildReply = (c) => {
  const anrede = c.name ? `Guten Tag ${c.name},` : 'Guten Tag,';
  const leistung = c.service ? ` zum Thema „${c.service}“` : '';
  const ort = c.location ? ` für Ihr Objekt in ${c.location}` : '';
  const rabatt = c.promo_code
    ? `\n\nIhr Rabattcode ${c.promo_code.toUpperCase()} ist bei uns hinterlegt: Als Neukunde erhalten Sie 30 % Rabatt auf Ihren ersten Auftrag – das berücksichtigen wir selbstverständlich direkt in unserem Angebot.`
    : '';
  const fotos = c.photos?.length ? `\n\nVielen Dank auch für die übermittelten Fotos – sie helfen uns sehr bei der ersten Einschätzung.` : '';

  const subject = `Ihre Anfrage bei ${company.name}${c.service ? ` – ${c.service}` : ''}`;
  const body = `${anrede}

vielen Dank für Ihre Anfrage${leistung}${ort}. Wir haben uns Ihr Anliegen angesehen und melden uns gerne mit einer konkreten Einschätzung und einem Angebot bei Ihnen.${fotos}${rabatt}

Damit wir Ihnen ein passendes Angebot erstellen können, benötigen wir noch kurz folgende Angaben:
– Ungefähre Größe der Fläche (in m²)
– Gewünschter Zeitraum für die Umsetzung
– Beste Erreichbarkeit für einen kurzen Rückruf

Gerne vereinbaren wir auch einen unverbindlichen Besichtigungstermin vor Ort.

Mit freundlichen Grüßen
${company.owner}
${company.name} – Sanierung · Reinigung · Pflege
${company.address.street}, ${company.address.zip} ${company.address.city}
Tel. ${company.phone}
${company.email}`;

  return { subject, body, mailto: `mailto:${c.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}` };
};
